// extracted by mini-css-extract-plugin
module.exports = {"partnerModal":"PartnerModal_partnerModal__S69QS","modalOpen":"PartnerModal_modalOpen__gEs5l"};